function getCartDrawerSectionId() {
  const drawer = document.querySelector("cart-drawer.cart-drawer-new");
  const section = drawer && drawer.closest('[id^="shopify-section-"]');
  if (section && section.id) {
    return section.id.replace(/^shopify-section-/, "");
  }
  return "cart-drawer";
}

let refreshCartGeneration = 0;
let refreshShouldOpenDrawer = false;

window.refreshCart = (opts) => {
  const generation = ++refreshCartGeneration;
  if (!opts || opts.open !== false) {
    refreshShouldOpenDrawer = true;
  }
  const sectionId = getCartDrawerSectionId();
  return fetch(`/cart?section_id=${encodeURIComponent(sectionId)}`)
    .then((response) => response.text())
    .then((responseText) => {
      if (generation !== refreshCartGeneration) return;
      const html = new DOMParser().parseFromString(responseText, "text/html");
      console.log("html:", html);
      const count = parseInt(
        html.querySelector("cart-drawer-items")?.getAttribute("item_count") ||
          "0",
        10
      );
      //console.log("count:", count);
      const selectors = [
        ".cart-drawer-new"
      ];
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        if (count > 0) {
          cartDrawer.classList.remove("is-empty");
          document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
            bubble.classList.remove("hidden");
          });
        } else {
          cartDrawer.classList.add("is-empty");
          document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
            bubble.classList.add("hidden");
          });
        }
      }
      //console.log(cartDrawer, selectors);
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        // console.log(
        //   { targetElement, sourceElement, selector },
        //   "<<<sourceElement"
        // );

          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        
      }
      document
        .querySelectorAll(".cart-count-bubble span:first-child")
        .forEach((bubble) => {
          bubble.textContent = count;
        });
      const totalItemElement = document.querySelector(".ttl_item");
      if (totalItemElement) {
        totalItemElement.textContent = count;
      }
      if (refreshShouldOpenDrawer) {
        refreshShouldOpenDrawer = false;
        $(".cart-drawer-main").addClass('drawer-open');
        $("body").addClass('body_stick');
      }
      try {
      } catch (err) {
        console.error("Error updating widgets:", err);
      }
    })
    .catch((error) => {
      console.error("Error refreshing cart:", error);
    })
    .finally(()=>{
      if (typeof renderApplied === "function") {
        renderApplied();
      }
    });
};

document.addEventListener("ajaxProduct:added", function () {
    if (typeof window.refreshCart === "function") {
        window.refreshCart();
    }
    requestPromoSync();
    setTimeout(function(){
      cart_drawer_upsell();
    },500);
});

$(document).on('click', '.cart-drawer__overlay, .drawer__close', function () {
    $(".cart-drawer-main").removeClass('drawer-open');
    $("body").removeClass('body_stick');
});
$(document).on('click', '#DrawerCartTrigger', function () {
    $(".cart-drawer-main").addClass('drawer-open');
    $("body").addClass('body_stick');
    requestPromoSync();
});

function updateCartQuantity($input, newQty) {
  const current_id = $input.attr('data-id');
  let updates = { [current_id]: newQty };
  enqueueCartWrite(function () {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ updates })
    })
      .then(response => response.json())
      .then(data => {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: {} }));
      });
  }).catch((error) => {
    console.error('Error:', error);
  });
}

// Plus / Minus buttons
$(document).on('click', '.drawer-qty__adjust--plus, .drawer-qty__adjust--minus', function () {
  const $input = $(this).closest('.js-qty__wrapper').find('.js-qty__num');
  let current_qty = parseInt($input.val()) || 1;

  if ($(this).hasClass('drawer-qty__adjust--plus')) {
    current_qty += 1;
  } else if ($(this).hasClass('drawer-qty__adjust--minus')) {
    current_qty = current_qty - 1;
  }
  updateCartQuantity($input, current_qty);
});

// Manual input change
$(document).on('change', '.cart_drawer_qty', function () {
  const $input = $(this);
  let current_qty = parseInt($input.val()) || 1;
  current_qty = current_qty < 1 ? 1 : current_qty;

  updateCartQuantity($input, current_qty);
});



$(document).on('click', '.cart_upsell_atc', function () {
      $(this).addClass('btn--loading active_atc');
      var product_id  = parseInt($(this).attr('product_id'));
      const items = [{ id: product_id, quantity: 1 }];
      enqueueCartWrite(function () {
        return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ items })
        })
        .then(response => response.json())
        .then(data => {
            document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
                detail: {}
            }));
        });
      }).catch(error => {
          console.error("Error:", error);
      });
});

//----------------------- Shipping and Product Progress Bar ----------------------
document.addEventListener('cart:updated', function() {
  console.log('cart:updated');
  requestPromoSync();
});

let cartWriteQueue = Promise.resolve();
let promoSyncQueue = Promise.resolve();
let promoSyncPending = false;

function enqueueCartWrite(fn) {
  cartWriteQueue = cartWriteQueue.then(fn, fn);
  return cartWriteQueue;
}

function fetchCartJson() {
  return fetch('/cart.js', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin'
  }).then(response => response.json());
}

function requestPromoSync() {
  promoSyncPending = true;
  promoSyncQueue = promoSyncQueue
    .then(function () {
      return (function runPromoSync(isFollowUp) {
        if (!promoSyncPending) return;
        promoSyncPending = false;
        return syncCartPromos().then(function (mutated) {
          if (mutated && !isFollowUp) {
            promoSyncPending = true;
            return runPromoSync(true);
          }
          if (promoSyncPending) return runPromoSync(false);
        });
      })(false);
    })
    .catch(function (error) {
      console.error('Error syncing cart promotions:', error);
    });
  return promoSyncQueue;
}

function syncCartPromos() {
  return fetchCartJson()
    .then(function (cart) {
      return applyBxgyGift(cart).then(function (bxgyMutated) {
        const nextCart = bxgyMutated ? fetchCartJson() : Promise.resolve(cart);
        return nextCart.then(function (freshCart) {
          return applyProgressBar(freshCart).then(function (progressMutated) {
            return bxgyMutated || progressMutated;
          });
        });
      });
    })
    .then(function (mutated) {
      if (!mutated) return false;
      if (typeof window.refreshCart === 'function') {
        return window.refreshCart({ open: false }).then(function () {
          return true;
        });
      }
      return true;
    });
}

function postFreeProductAdd(product_id) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ id: product_id, quantity: 1 })
  }).then(function (response) {
    return response.json().then(function (data) {
      return { ok: response.ok, data: data };
    });
  });
}

function addfree_product(product_id) {
  return enqueueCartWrite(function () {
    return postFreeProductAdd(product_id).then(function (result) {
      if (result.ok && !result.data.status) return true;
      if (result.data && result.data.status === 422) {
        console.error('Error adding free product to cart:', result.data);
        return false;
      }
      return new Promise(function (resolve) {
        setTimeout(resolve, 250);
      }).then(function () {
        return postFreeProductAdd(product_id).then(function (retryResult) {
          if (retryResult.ok && !retryResult.data.status) return true;
          console.error('Error adding free product to cart:', retryResult.data);
          return false;
        });
      });
    });
  }).catch(function (error) {
    console.error('Error adding free product to cart:', error);
    return false;
  });
}

function remove_freeproduct(product_id) {
  var product_ = parseInt(product_id, 10);
  let updates = { [product_]: 0 };
  return enqueueCartWrite(function () {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ updates })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (result.ok && !result.data.status) return true;
        console.error('Error removing free product from cart:', result.data);
        return false;
      });
  }).catch(function (error) {
    console.error('Error:', error);
    return false;
  });
}

function progressBar() {
  return fetchCartJson()
    .then(function (cart) {
      return applyProgressBar(cart);
    })
    .catch(function (error) {
      console.error('Error fetching cart data:', error);
      return false;
    });
}

function applyProgressBar(cart) {
    const progressBarMain = document.querySelector('.progress_bar_main');
    if (!progressBarMain) return Promise.resolve(false);

    const freeproduct_threshold = parseInt(progressBarMain.getAttribute('freeproduct_threshold'), 10);
    const free_product_id = parseInt(progressBarMain.getAttribute('free_product_id'), 10) || 0;
    const free_product_available = progressBarMain.getAttribute('free_product_available');
    const excluded_products = progressBarMain.getAttribute('excluded_products')?.split(',').map(id => parseInt(id, 10)) || [];

    if (!freeproduct_threshold || !free_product_id || free_product_available !== 'true') {
      return Promise.resolve(false);
    }

    const cartTotal = cart.items.reduce((total, item) => {
        if (!excluded_products.includes(item.product_id)) {
            return total + (item.final_price * item.quantity);
        }
        return total;
    }, 0);
    console.log('total😅',cartTotal)
    const hasFreeProduct = cart.items.some(item => item.id === free_product_id);

    if (hasFreeProduct && cartTotal < freeproduct_threshold) {
        return remove_freeproduct(free_product_id);
    } else if (!hasFreeProduct && cartTotal > freeproduct_threshold) {
        return addfree_product(free_product_id);
    }
    return Promise.resolve(false);
}

//----------------------- Buy X Get Y Free Gift ----------------------
function bxgyGift() {
  return fetchCartJson()
    .then(function (cart) {
      return applyBxgyGift(cart);
    })
    .catch(function (error) {
      console.error('Error fetching cart data for Buy X Get Y:', error);
      return false;
    });
}

function applyBxgyGift(cart) {
    const bxgyConfig = document.querySelector('.bxgy-gift-config');
    if (!bxgyConfig) return Promise.resolve(false);

    if (bxgyConfig.getAttribute('bxgy_enabled') !== 'true') return Promise.resolve(false);

    const trigger_ids = bxgyConfig.getAttribute('bxgy_trigger_ids')
        ?.split(',')
        .map(id => parseInt(id, 10))
        .filter(id => !isNaN(id)) || [];
    const gift_product_id = parseInt(bxgyConfig.getAttribute('bxgy_gift_product_id'), 10) || 0;
    const gift_variant_id = parseInt(bxgyConfig.getAttribute('bxgy_gift_variant_id'), 10) || 0;
    const gift_available = bxgyConfig.getAttribute('bxgy_available') === 'true';

    // Without at least one trigger product and a gift product there is nothing to do.
    if (!trigger_ids.length || !gift_product_id) return Promise.resolve(false);

    const hasTrigger = cart.items.some(item =>
        item.product_id !== gift_product_id && trigger_ids.includes(item.product_id)
    );
    const giftLine = cart.items.find(item => item.product_id === gift_product_id);

    // Sold out: the gift must never remain in the cart, regardless of triggers.
    if (!gift_available) {
        if (giftLine) {
            return remove_freeproduct(giftLine.id);
        }
        return Promise.resolve(false);
    }

    if (hasTrigger && !giftLine && gift_variant_id) {
        return addfree_product(gift_variant_id);
    } else if (!hasTrigger && giftLine) {
        return remove_freeproduct(giftLine.id);
    }
    return Promise.resolve(false);
}

function cart_drawer_upsell() {
  setTimeout(function() {
    const cartUpsellMain = document.querySelector('.cart_upsell_main');
    const cartUpsellList = document.querySelector('.cart_upsell_list');
    if (cartUpsellMain && cartUpsellList) {
      cartUpsellMain.style.display = 'block';
      requestAnimationFrame(() => {
        const flkty = new Flickity(cartUpsellList, {
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          groupCells: 1,
          wrapAround: false
        });
      });
    }
  }, 1000);
}
cart_drawer_upsell();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', requestPromoSync);
} else {
  requestPromoSync();
}

function openCartDrawerFromUrl() {
  try {
    var params = new URLSearchParams(window.location.search);
    if (window.theme && window.theme.settings && window.theme.settings.cartType === 'page') {
      if (params.get('open_cart') === '1') {
        params.delete('open_cart');
        var qsPage = params.toString();
        var cleanPage =
          window.location.pathname + (qsPage ? '?' + qsPage : '') + window.location.hash;
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, '', cleanPage);
        }
      }
      return;
    }
    if (params.get('open_cart') !== '1') return;
    params.delete('open_cart');
    var qs = params.toString();
    var clean =
      window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', clean);
    }
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    } else if (typeof $ !== 'undefined') {
      $('.cart-drawer-main').addClass('drawer-open');
      $('body').addClass('body_stick');
    }
  } catch (e) {
    console.error('openCartDrawerFromUrl:', e);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', openCartDrawerFromUrl);
} else {
  openCartDrawerFromUrl();
}

function isCartDrawerDropdownMode() {
  return !(
    window.theme &&
    window.theme.settings &&
    window.theme.settings.cartType === 'page'
  );
}

function openCartDrawerOnCurrentPage() {
  if (typeof window.refreshCart === 'function') {
    window.refreshCart();
  } else if (typeof $ !== 'undefined') {
    $('.cart-drawer-main').addClass('drawer-open');
    $('body').addClass('body_stick');
  }
}

function getCartLinkType(url) {
  var helper = window.theme && window.theme.cartDrawerReturn;
  if (!helper) return null;

  var base = helper.normalizePath(helper.cartBase);
  var path = helper.normalizePath(url.pathname);

  if (path === base) return 'bare';

  if (path.indexOf(base + '/') === 0) {
    var rest = path.slice(base.length + 1);
    if (rest && !/^change$/i.test(rest) && !/^add$/i.test(rest)) {
      return 'permalink';
    }
  }

  return null;
}

function parseCartPermalink(url) {
  var helper = window.theme && window.theme.cartDrawerReturn;
  if (!helper || getCartLinkType(url) !== 'permalink') return null;

  var base = helper.normalizePath(helper.cartBase);
  var path = helper.normalizePath(url.pathname);
  var segment = decodeURIComponent(path.slice(base.length + 1));
  var items = [];

  segment.split(',').forEach(function (part) {
    part = part.trim();
    if (!part) return;
    var colon = part.lastIndexOf(':');
    if (colon === -1) return;
    var id = parseInt(part.slice(0, colon), 10);
    var qty = parseInt(part.slice(colon + 1), 10);
    if (id && qty > 0) {
      items.push({ id: id, quantity: qty });
    }
  });

  if (!items.length) return null;

  var properties = {};
  url.searchParams.forEach(function (value, key) {
    var match = key.match(/^properties\[(.+)\]$/);
    if (match) {
      properties[match[1]] = value;
    }
  });

  return {
    items: items,
    note: url.searchParams.get('note') || '',
    properties: properties
  };
}

function getCartAddUrl() {
  if (window.theme && window.theme.routes && window.theme.routes.cartAdd) {
    return window.theme.routes.cartAdd;
  }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return root.replace(/\/?$/, '/') + 'cart/add.js';
}

function getCartUpdateUrl() {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return root.replace(/\/?$/, '/') + 'cart/update.js';
}

function applyCartPermalink(url) {
  var payload = parseCartPermalink(url);
  if (!payload) return Promise.resolve(false);

  var items = payload.items.map(function (item) {
    var line = { id: item.id, quantity: item.quantity };
    if (Object.keys(payload.properties).length) {
      line.properties = payload.properties;
    }
    return line;
  });

  return fetch(getCartAddUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ items: items })
  })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    })
    .then(function () {
      if (!payload.note) return null;
      return fetch(getCartUpdateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ note: payload.note })
      });
    })
    .then(function () {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: {} }));
      return true;
    })
    .catch(function (err) {
      console.error('Cart permalink AJAX failed:', err);
      return false;
    });
}

function setCartLinkLoading(link, loading) {
  if (!link) return;
  if (loading) {
    link.setAttribute('aria-busy', 'true');
    link.classList.add('cart-permalink-loading');
    if (link.classList.contains('btn')) {
      link.classList.add('btn--loading');
    }
  } else {
    link.removeAttribute('aria-busy');
    link.classList.remove('cart-permalink-loading', 'btn--loading');
  }
}

function fallbackCartPermalinkNavigation(href) {
  if (window.theme && window.theme.cartDrawerReturn && window.theme.cartDrawerReturn.storeCurrentPage) {
    window.theme.cartDrawerReturn.storeCurrentPage();
  }
  window.location.href = href;
}

function initCartLinkHandling() {
  if (!isCartDrawerDropdownMode()) return;

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('a[href]');
      if (!link || link.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
        return;
      }

      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;

      try {
        var url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) return;

        var cartLinkType = getCartLinkType(url);

        if (cartLinkType === 'bare') {
          e.preventDefault();
          openCartDrawerOnCurrentPage();
          return;
        }

        if (cartLinkType === 'permalink') {
          e.preventDefault();
          if (link.classList.contains('cart-permalink-loading')) return;

          setCartLinkLoading(link, true);
          applyCartPermalink(url).then(function (ok) {
            setCartLinkLoading(link, false);
            if (ok) {
              openCartDrawerOnCurrentPage();
            } else {
              fallbackCartPermalinkNavigation(href);
            }
          });
        }
      } catch (err) {}
    },
    true
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartLinkHandling);
} else {
  initCartLinkHandling();
}
